import React, { useState, ReactNode } from "react";
import { FontStyles } from "../../utils/font-styles.ts";

interface TabProps extends React.PropsWithChildren {
  labels: string[];
  onTabChange?: (activeTab: string) => void;
  initialTab?: string;
}

const baseStyle = "font-semibold py-2 w-1/2 " + FontStyles["body-md"];
const activeStyle = "text-slate border-b-2 border-north-sea";
const inactiveStyle = "text-neutral-200 border-b-2 border-neutral-200";
const contentStyle = "text-light-slate " + FontStyles["body-l"];

export const Tabs: React.FC<TabProps> = ({ labels, children, onTabChange, initialTab }) => {
  const tabIndex = initialTab ? labels.indexOf(initialTab) : 0;
  const [activeTab, setActiveTab] = useState(tabIndex);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(labels[index]); // Call onTabChange with the label of the active tab
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="w-full">
        {labels.map((label, index) => {
          const isActive = index === activeTab;
          const tabStyle = `${baseStyle} ${isActive ? activeStyle : inactiveStyle}`;

          return (
            <button key={index} onClick={() => handleTabClick(index)} className={tabStyle}>
              {label}
            </button>
          );
        })}
      </div>
      <div className={contentStyle}>{children && (children as ReactNode[])[activeTab]}</div>
    </div>
  );
};
